module.exports = __webpack_public_path__ + "static/SteelRidge_Logo-767050abe294c7f3ff2a41029fa349bb.png";